import { useAtomValue } from 'jotai'
import React from 'react'

import { hiddenLabelBrandIdsAtom, isPercentageAtom } from '../atoms'
import { getDatum, isPercentageOnlyIndicator, type SeriesItem } from '../utils'

import { useBrandsData } from './useBrandsData'
import { useVisibleBrands } from './useVisibleBrands'
import { useVisibleSurveys } from './useVisibleSurveys'

export const useBrandSeries = (indicator: string): SeriesItem[] => {
  const brands = useVisibleBrands()
  const surveys = useVisibleSurveys()
  const brandsData = useBrandsData()
  const isPercentageOnly = isPercentageOnlyIndicator(indicator)
  const isPercentage = useAtomValue(isPercentageAtom) || isPercentageOnly
  const hiddenLabelBrandIds = useAtomValue(hiddenLabelBrandIdsAtom)

  return React.useMemo(
    () =>
      brands.map((brand) => ({
        data: surveys.map((survey) =>
          getDatum(
            brandsData,
            (item) =>
              item.brandId === brand.id &&
              item.surveyId === survey.id &&
              item.indicator === indicator,
            isPercentage,
          ),
        ),
        name: brand.name,
        isLabelVisible: !hiddenLabelBrandIds.includes(brand.id),
      })),
    [brands, brandsData, hiddenLabelBrandIds, indicator, isPercentage, surveys],
  )
}
